/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-question-look-2': {
    width: 55,
    height: 33,
    viewBox: '0 0 55 33',
    data: '<path pid="0" class="st0" d="M5.2 3.6c5 .2 9 1.7 12.1 4.3 2 1.7 2.9 3.4 3.2 4.1v8.9c-.6 1.4-4.3 7.9-15.3 8.4C4.6 27 3.5 22 3.5 16.5S4.7 5.9 5.2 3.6m18.9 9.8h6.6v6.1h-6.6v-6.1zm13.5-5.5c3-2.6 7.1-4.1 12.1-4.3.6 2.3 1.7 7.3 1.7 12.8 0 5.5-1.1 10.5-1.7 12.8-5-.2-9-1.7-12.1-4.3-2-1.7-2.9-3.4-3.2-4.1V12c.3-.7 1.2-2.4 3.2-4.1M2.2 31.5l.4 1.3h1.3c8.2 0 13.2-2.9 16-5.4 1.9-1.7 3-3.4 3.6-4.5h8c.6 1.1 1.7 2.8 3.6 4.5 2.8 2.4 7.8 5.4 16 5.4h1.3l.4-1.3c.1-.3 2.2-7.1 2.2-15.1S52.9 1.5 52.8 1.3L52.3 0H51c-8.2 0-13.2 2.9-16 5.4-1.9 1.7-3 3.3-3.6 4.4h-8c-.6-1.1-1.7-2.8-3.6-4.4C17.1 2.9 12.1 0 3.9 0H2.6l-.4 1.3C2.1 1.5 0 8.4 0 16.4s2.1 14.9 2.2 15.1"/>'
  }
})
